// extracted by mini-css-extract-plugin
module.exports = {"documentNameLink":"ConditionsDetail_AX_documentNameLink__M8ZP6"};